import React, { useState } from 'react'
import './landing.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'
import IndexLanding from './IndexLanding'
import logoAgendate from '../../img/logoAgendate3.png'
import QuienesSomosLanding from './QuienesSomosLanding'
import CatalogoLanding from './CatalogoLanding'
import ContactenosLanding from './ContactenosLanding'

const LandingAgendaTe = ({ setSelectActionPublicZone }) => {

    const [selectZoneLanding, setSelectZoneLanding] = useState('LANDING_INDEX')
    const [openMenuResponsive, setOpenMenuResponsive] = useState(false)

    const componentValidated = () => {
        switch (selectZoneLanding) {
            case 'LANDING_INDEX':
                return (
                    <IndexLanding setSelectActionPublicZone={setSelectActionPublicZone} />
                )
            case 'LANDING_CATALOGO':
                return (
                    <CatalogoLanding />
                )
            case 'LANDING_QUIENES_SOMOS':
                return (
                    <QuienesSomosLanding />
                )
            case 'LANDING_CONTACTENOS':
                return (
                    <ContactenosLanding />
                )
            default:
                return (
                    <></>
                )
        }
    }

    const handleSelectZoneLanding = (zone) => {
        setSelectZoneLanding(zone)
        setOpenMenuResponsive(false)
    }

    return (
        <>
            <div className='div-header-landing'>
                <div className="row m-0">
                    <div className="col-6 col-sm-6 col-md-6 col-lg-4 p-0" >
                        <div className='div-landing-logo'>
                            <img src={logoAgendate} alt='logoAgendate' className='img-logo-agendate' onClick={() => handleSelectZoneLanding('LANDING_INDEX')}></img>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-8 p-0 element-row-display-responsive" >
                        <div className='div-landing-menu-bars'>
                            {
                                openMenuResponsive ?
                                    <>
                                        <FontAwesomeIcon className='icon-menu-bars-landing' icon={faTimes} onClick={() => setOpenMenuResponsive(!openMenuResponsive)} />
                                    </>
                                    :
                                    <>
                                        <p className='p-landing-menu-bars mx-3'> Menú </p>
                                        <FontAwesomeIcon className='icon-menu-bars-landing' icon={faBars} onClick={() => setOpenMenuResponsive(!openMenuResponsive)} />
                                    </>
                            }
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-8 p-0 element-row-display" >
                        <div className='div-landing-menu'>
                            <button onClick={() => handleSelectZoneLanding('LANDING_INDEX')}
                                className={selectZoneLanding === 'LANDING_INDEX' ? 'btn btn-link a-buttom-landing-active' : 'btn btn-link a-buttom-landing'} >Inicio</button>
                            <button onClick={() => handleSelectZoneLanding('LANDING_QUIENES_SOMOS')}
                                className={selectZoneLanding === 'LANDING_QUIENES_SOMOS' ? 'btn btn-link a-buttom-landing-active' : 'btn btn-link a-buttom-landing'}>Quienes somos</button>
                            {
                                /*
                                <button onClick={() => handleSelectZoneLanding('LANDING_CATALOGO')}
                                    className={selectZoneLanding === 'LANDING_CATALOGO' ? 'btn btn-link a-buttom-landing-active' : 'btn btn-link a-buttom-landing'}>Ver catálogo</button>
                                */
                            }
                            <button onClick={() => handleSelectZoneLanding('LANDING_CONTACTENOS')}
                                className={selectZoneLanding === 'LANDING_CONTACTENOS' ? 'btn btn-link a-buttom-landing-active' : 'btn btn-link a-buttom-landing'}>Contáctanos</button>
                            <button className='btn btn-link a-buttom-landing' onClick={() => setSelectActionPublicZone('REGISTRA_AGENDATE')}>Regístrate</button>
                            <button className='btn btn-link a-buttom-landing' onClick={() => setSelectActionPublicZone('LOGIN_AGENDATE')} >Iniciar Sesión</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={openMenuResponsive ? 'div-menu-responsive-landing-active' : 'div-menu-responsive-landing'} >
                <div className='div-landing-menu-responsive'>
                    <button onClick={() => handleSelectZoneLanding('LANDING_INDEX')}
                        className={selectZoneLanding === 'LANDING_INDEX' ? 'btn btn-link a-buttom-landing-active' : 'btn btn-link a-buttom-landing'} >Inicio</button>
                    <button onClick={() => handleSelectZoneLanding('LANDING_QUIENES_SOMOS')}
                        className={selectZoneLanding === 'LANDING_QUIENES_SOMOS' ? 'btn btn-link a-buttom-landing-active' : 'btn btn-link a-buttom-landing'}>Quienes somos</button>
                    {
                        /*
                            <button onClick={() => handleSelectZoneLanding('LANDING_CATALOGO')}
                                className={selectZoneLanding === 'LANDING_CATALOGO' ? 'btn btn-link a-buttom-landing-active' : 'btn btn-link a-buttom-landing'}>Ver catálogo</button>
                        */
                    }
                    <button onClick={() => handleSelectZoneLanding('LANDING_CONTACTENOS')}
                        className={selectZoneLanding === 'LANDING_CONTACTENOS' ? 'btn btn-link a-buttom-landing-active' : 'btn btn-link a-buttom-landing'}>Contáctanos</button>
                    <button className='btn btn-link a-buttom-landing' onClick={() => setSelectActionPublicZone('REGISTRA_AGENDATE')}>Regístrate</button>
                    <button className='btn btn-link a-buttom-landing' onClick={() => setSelectActionPublicZone('LOGIN_AGENDATE')} >Iniciar Sesión</button>
                </div>
            </div>
            <div className='div-header-landing-padre'>
                {
                    componentValidated()
                }
            </div>
            <br /><br /><br /><br /><br />
        </>
    )
}

export default LandingAgendaTe